import React from 'react';
import PropTypes from 'prop-types';

import Top from './components/Top';
import Body from './components/Body';

import { useScreenClass } from 'components/Grid';

import {
  Section,
} from './styles';

const Hero = ({ isCompacted }) => {
  const screenClass = useScreenClass();

  return (
    <Section style={{
      backgroundImage: !isCompacted
        ? 'linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(17, 17, 17, 0.5)), url("/assets/images/hero/background-hero@2x.jpg")'
        : 'url("/assets/images/hero/inverted-background-hero@3x.jpg")',
      backgroundPosition: screenClass === 'xs' ? '-550px' : 'center'
    }}>
      {!isCompacted && <Top />}
      <Body isCompacted={isCompacted} />
    </Section>
  );
};

Hero.propTypes = {
  isCompacted: PropTypes.bool,
};

export default Hero;
